import { Auth } from 'Shared/auth';
import { listenGlobal } from 'Shared/utils/global-events';
import { onDomReady } from 'Shared/utils/dom-ready';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

const track = (action, params = {}) =>
   trackAnalyticsCustomEvent({
      eventCategory: 'Document Teaser',
      eventAction: `Document Teaser - ${action}`,
      ...params,
   });

onDomReady(() => {
   track('View');
   listenGlobal('login.success', response =>
      track('Login Success', {
         method: response.from ?? 'unknown',
         new_user: response.newUser ? 'true' : 'false',
      })
   );

   const openLoginModal = register => {
      Auth.required({
         register,
         onAuthorize: () => window.location.reload(),
         onCancel: () => track('Login Modal Dismiss'),
      });
   };

   const wireCta = (id, action, register) => {
      // The download CTA only renders when the document has a preview image.
      document.getElementById(id)?.addEventListener('click', event => {
         event.preventDefault();
         track(action);
         openLoginModal(register);
      });
   };

   wireCta('documentTeaserSignup', 'Signup CTA Click', true);
   wireCta('documentTeaserLogin', 'Login CTA Click', false);
   wireCta('documentTeaserDownload', 'Download CTA Click', true);
});
